import { FormDetails } from '../../empracoTypes';
import { handleCaptcha, refreshCaptcha } from './handleCaptcha';
import { handleFileChanges } from './handleFileChanges';

export const formTexts = {
  noFiles: 'No files',
  clearTitle: 'Clear the files in this input',
  fileRequiredError: 'Please select a file as it is required',
  validationError: 'Could not send form. Check validation errors!'
};

export interface ValidationProps {
  formDetails: FormDetails;
  form: HTMLFormElement;
}

export default async function FormSelectorFns(formDetails: FormDetails) {

  const form = document.getElementById(formDetails.formId) as HTMLFormElement;
  if (!form) {
    return;
  }
  // Handle empori captcha
  if (formDetails.spamProtectionDetails.isEmporiCaptchaEnabled) { handleCaptcha(formDetails); }

  // Sets event listeners to file input changes in the current form.
  handleFileChanges(formDetails, form);

  // Validate the form and use event.preventDefault() to stop the form from submitting.
  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    const submitter = event.submitter;
    if (!submitter || submitter && submitter.nodeName !== 'INPUT') {
      return;
    }

    const statusEl = document.getElementById(formDetails.statusKey);

    if (statusEl) {
      statusEl.style.display = 'block';
      statusEl.innerHTML = '<i class="fa-regular fa-spinner fa-spin"></i><span>Skickar formulärsdata...</span>';
    }

    const messageEl = document.getElementById(formDetails.messageKey);

    try {
      await fetch(formDetails.fetchUrl, {
        method: 'POST',
        body: new FormData(form),
        redirect: 'follow'
      }).then(res => {
        if (res.redirected) {
          window.location.href = res.url;
        } else if (res.ok) {
          form.style.display = 'none';
          if (messageEl) {
            messageEl.style.display = 'block';
          }
          if (statusEl) {
            statusEl.style.display = 'none';
          }
        } else {
          if (statusEl) {
            res.text().then(errorMsg => {
              statusEl.innerHTML = `<i class="fa-regular fa-times"></i><span>${errorMsg}</span>`;
              statusEl.classList.add('not-autorized');
              refreshCaptcha(formDetails);
            });
          }
        }
      }).catch(err => {
        if (statusEl) {
          statusEl.innerHTML = `<pre>${err}</pre>`;
        }
      });
    } catch (error) {
      if (statusEl) {
        statusEl.innerHTML = `<pre>${error}</pre>`;
      }
    }
  });
}

